import { ensureJourneyDb, getById, listTable, updateRow, writeAudit } from "../../db";
import { resolveActor } from "./access";
import { forbidden, notFound } from "./errors";

/** POST /api/clients/email-opt-in */
export function postClientEmailOptIn(body = {}, session) {
  ensureJourneyDb();
  const actor = resolveActor(session);
  const isClient = actor.journeyRole === "buyer" || actor.journeyRole === "seller";
  if (!isClient && !actor.isAdmin) {
    throw forbidden("Only the client can change report email opt-in");
  }
  const userId = actor.isAdmin && body.user_id ? body.user_id : actor.userId;
  if (userId !== actor.userId && !actor.isAdmin) {
    throw forbidden("You can only change your own email preference");
  }
  const user = getById("users", userId);
  if (!user) throw notFound("User not found");
  const optedIn = Boolean(body.email_report_opt_in);
  const next = updateRow("users", userId, {
    email_report_opt_in: optedIn,
  });
  const files = listTable("transactions").filter((row) => row.client_id === userId);
  if (files.length === 0) {
    writeAudit({
      user_id: actor.userId,
      action_type: "email.opt_in",
      transaction_id: null,
      metadata: { email_report_opt_in: optedIn, client_id: userId },
    });
  } else {
    files.forEach((row) => {
      writeAudit({
        user_id: actor.userId,
        action_type: "email.opt_in",
        transaction_id: row.id,
        metadata: { email_report_opt_in: optedIn, client_id: userId },
      });
    });
  }
  return next;
}
